import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// import Container from "../../components/container";
import { ReactComponent as ArrowLeft } from "../../Assets/icons/arrow-left.svg";

import "./style.scss";
const Error = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div
      props={{ "data-show": "orders" }}
      title={"جزئیات سفارش"}
      link={() => {
        return (
          <Link to="/orders">
            <span>مشاهده همه سفارشات</span>
            <ArrowLeft />
          </Link>
        );
      }}
    >
      <div className="payment-page">
        <div className="payment-box-error">
          <img src={require("../../Assets/images/sad.png")} />
          <p className="toast-message">متاسفانه پرداخت شما موفق نبود</p>
          <p className="text-sub text-center">
            در صورت کسر وجه از حسابتان مبلغ تا ۱۵ دقیقه به حسابتان بازگردانده
            خواهد شد.
            <br />
            در صورت وجود مشکل با پشتیبانی در تماس باشید.
          </p>
          {/* <div className="tracking-code">
            <p>کد پیگیری پرداخت: </p>
            <p>{id}</p>
          </div> */}
          {/* <div className="button-wrapper">
            <button onClick={() => navigate("/my-products")}>
              <p>ادامه فرایند</p>
              <span className="icon-left-wrapper">
                {" "}
                <ArrowLeft />
              </span>
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Error;
